/**
 * Utilitaires pour générer les clés localStorage de manière cohérente
 * entre ShareModal, File.jsx, et autres composants
 */

/**
 * Génère la clé localStorage pour les documents médicaux partagés
 * Normalise les IDs (UUID, number, string) pour assurer la cohérence
 * @param {string|number} patientId - L'ID du patient
 * @returns {string} La clé localStorage normalisée
 */
export function getSharedDocsStorageKey(patientId) {
  if (!patientId) return null;
  
  // Convertir en string et nettoyer
  const normalized = String(patientId).trim().toLowerCase();
  
  return `shared_medical_docs_${normalized}`;
}

/**
 * Récupère les documents partagés depuis localStorage
 * @param {string|number} patientId - L'ID du patient
 * @returns {Array} Les documents partagés
 */
export function getSharedDocsFromStorage(patientId) {
  const key = getSharedDocsStorageKey(patientId);
  if (!key) return [];
  
  try {
    const data = localStorage.getItem(key);
    return Array.isArray(JSON.parse(data || "[]")) ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

/**
 * Sauvegarde les documents partagés dans localStorage
 * @param {string|number} patientId - L'ID du patient
 * @param {Array} documents - Les documents à sauvegarder
 * @returns {boolean} true si succès, false sinon
 */
export function setSharedDocsInStorage(patientId, documents) {
  const key = getSharedDocsStorageKey(patientId);
  if (!key) return false;
  
  try {
    localStorage.setItem(key, JSON.stringify(documents));
    return true;
  } catch {
    return false;
  }
}
